var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"v-datatable__progress"},[_c('th',{staticClass:"column",attrs:{"colspan":_vm.itemsLength}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"2","value":"1"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }